import { Route, useNavigate } from "react-router-dom";

// Player Pages
import HomePage from "../pages/HomePage";
import EventDetailsPage from "../pages/EventDetailsPage";
import CreateEventPage from "../pages/CreateEventPage";
import EditEventPage from "../pages/EditEventPage";
import CalendarPage from "../pages/CalendarPage";
import MessagesPage from "../pages/MessagesPage";
import ChatPage from "../pages/ChatPage";
import ProfilePage from "../pages/ProfilePage";
import EditProfilePage from "../pages/EditProfilePage";
import LeaderboardPage from "../pages/LeaderboardPage";
import AchievementsPage from "../pages/AchievementsPage";
import ShopsPage from "../pages/ShopsPage";
import ShopDetailPage from "../pages/ShopDetailPage";
import TournamentsPage from "../pages/TournamentsPage";
import TournamentDetailPage from "../pages/TournamentDetailPage";
import CreateTournamentPage from "../pages/CreateTournamentPage";
import AIAssistantPage from "../pages/AIAssistantPage";
import RulesPage from "../pages/RulesPage";
import TutorialPage from "../pages/TutorialPage";
import SetupGuidePage from "../pages/SetupGuidePage";
import LiveTrackerPage from "../pages/LiveTrackerPage";
import MatchmakingPage from "../pages/MatchmakingPage";
import GameNightPlannerPage from "../pages/GameNightPlannerPage";
import PaymentsPage from "../pages/PaymentsPage";
import PaymentSuccessPage from "../pages/PaymentSuccessPage";
import VoiceAssistantPage from "../pages/VoiceAssistantPage";
import CatanStatsPage from "../pages/CatanStatsPage";
import PremiumPage from "../pages/PremiumPage";
import PricingPage from "../pages/PricingPage";
import ShopProfilePage from "../pages/ShopProfilePage";
import PublisherPage from "../pages/PublisherPage";
import DiscoverPage from "../pages/DiscoverPage";
import GameStatsPage from "../pages/GameStatsPage";
import SeasonPassPage from "../pages/SeasonPassPage";
import MultiGameStatsPage from "../pages/MultiGameStatsPage";
import SponsoredTournamentsPage from "../pages/SponsoredTournamentsPage";
import FriendsPage from "../pages/FriendsPage";
import GroupsPage from "../pages/GroupsPage";
import GroupDetailPage from "../pages/GroupDetailPage";
import NotificationsPage from "../pages/NotificationsPage";
import NotificationSettingsPage from "../pages/NotificationSettingsPage";
import SavedAlertsPage from "../pages/SavedAlertsPage";
import ShopOnboardingPage from "../pages/ShopOnboardingRedirect";
import PublisherOnboardingPage from "../pages/PublisherSignupPage";
import ShopLeaderboardPage from "../pages/ShopLeaderboardPage";
import RecurringGroupsPage from "../pages/RecurringGroupsPage";
import CreateRecurringGroupPage from "../pages/CreateRecurringGroupPage";
import RecurringGroupDetailPage from "../pages/RecurringGroupDetailPage";
import LeaguesPage from "../pages/LeaguesPage";
import CreateLeaguePage from "../pages/CreateLeaguePage";
import LeagueDetailPage from "../pages/LeagueDetailPage";
import ShopLocatorPage from "../pages/ShopLocatorPage";
import BotPracticePage from "../pages/BotPracticePage";
import CheckInPage from "../pages/CheckInPage";
import PushSettingsPage from "../pages/PushSettingsPage";
import MobileDiscoveryPage from "../pages/MobileDiscoveryPage";
import MyCollectionPage from "../pages/MyCollectionPage";
import OnboardingWizard from "../pages/OnboardingWizard";
import CharacterSheetsPage from "../pages/CharacterSheetsPage";
import WargameRostersPage from "../pages/WargameRostersPage";
import GameRulesPdfPage from "../pages/admin/GameRulesPdfPage";

export function PlayerRoutes({ ProtectedRoute }) {
  return (
    <>
      <Route path="/onboarding" element={<ProtectedRoute><OnboardingPage /></ProtectedRoute>} />
      <Route path="/home" element={<ProtectedRoute><HomePage /></ProtectedRoute>} />
      <Route path="/discover" element={<ProtectedRoute><DiscoverPage /></ProtectedRoute>} />
      <Route path="/events/:id" element={<ProtectedRoute><EventDetailsPage /></ProtectedRoute>} />
      <Route path="/events/:id/edit" element={<ProtectedRoute><EditEventPage /></ProtectedRoute>} />
      <Route path="/create-event" element={<ProtectedRoute><CreateEventPage /></ProtectedRoute>} />
      <Route path="/calendar" element={<ProtectedRoute><CalendarPage /></ProtectedRoute>} />
      <Route path="/messages" element={<ProtectedRoute><MessagesPage /></ProtectedRoute>} />
      <Route path="/chat/:userId" element={<ProtectedRoute><ChatPage /></ProtectedRoute>} />
      <Route path="/profile" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/profile/edit" element={<ProtectedRoute><EditProfilePage /></ProtectedRoute>} />
      <Route path="/profile/:userId" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/user/:userId" element={<ProtectedRoute><ProfilePage /></ProtectedRoute>} />
      <Route path="/leaderboard" element={<ProtectedRoute><LeaderboardPage /></ProtectedRoute>} />
      <Route path="/achievements" element={<ProtectedRoute><AchievementsPage /></ProtectedRoute>} />
      <Route path="/shops" element={<ProtectedRoute><ShopsPage /></ProtectedRoute>} />
      <Route path="/shops/:shopId" element={<ProtectedRoute><ShopDetailPage /></ProtectedRoute>} />
      <Route path="/tournaments" element={<ProtectedRoute><TournamentsPage /></ProtectedRoute>} />
      <Route path="/tournaments/:tournamentId" element={<ProtectedRoute><TournamentDetailPage /></ProtectedRoute>} />
      <Route path="/create-tournament" element={<ProtectedRoute><CreateTournamentPage /></ProtectedRoute>} />
      <Route path="/ai" element={<ProtectedRoute><AIAssistantPage /></ProtectedRoute>} />
      <Route path="/rules" element={<ProtectedRoute><RulesPage /></ProtectedRoute>} />
      <Route path="/rules/:slug" element={<ProtectedRoute><RulesPage /></ProtectedRoute>} />
      <Route path="/tutorial" element={<ProtectedRoute><TutorialPage /></ProtectedRoute>} />
      <Route path="/setup-guide" element={<ProtectedRoute><SetupGuidePage /></ProtectedRoute>} />
      <Route path="/live-tracker/:sessionId" element={<ProtectedRoute><LiveTrackerPage /></ProtectedRoute>} />
      <Route path="/matchmaking" element={<ProtectedRoute><MatchmakingPage /></ProtectedRoute>} />
      <Route path="/planner" element={<ProtectedRoute><GameNightPlannerPage /></ProtectedRoute>} />
      <Route path="/payments" element={<ProtectedRoute><PaymentsPage /></ProtectedRoute>} />
      <Route path="/payment-success" element={<ProtectedRoute><PaymentSuccessPage /></ProtectedRoute>} />
      <Route path="/voice" element={<ProtectedRoute><VoiceAssistantPage /></ProtectedRoute>} />
      <Route path="/catan-stats" element={<ProtectedRoute><CatanStatsPage /></ProtectedRoute>} />
      <Route path="/catan-stats/:userId" element={<ProtectedRoute><CatanStatsPage /></ProtectedRoute>} />
      <Route path="/premium" element={<ProtectedRoute><PremiumPage /></ProtectedRoute>} />
      <Route path="/pricing" element={<ProtectedRoute><PricingPage /></ProtectedRoute>} />
      <Route path="/shop-profile/:shopId" element={<ProtectedRoute><ShopProfilePage /></ProtectedRoute>} />
      <Route path="/publishers" element={<ProtectedRoute><PublisherPage /></ProtectedRoute>} />
      <Route path="/publishers/:publisherId" element={<ProtectedRoute><PublisherPage /></ProtectedRoute>} />
      <Route path="/game-stats" element={<ProtectedRoute><GameStatsPage /></ProtectedRoute>} />
      <Route path="/game-stats/:userId" element={<ProtectedRoute><GameStatsPage /></ProtectedRoute>} />
      <Route path="/season-pass" element={<ProtectedRoute><SeasonPassPage /></ProtectedRoute>} />
      <Route path="/game-hub" element={<ProtectedRoute><MultiGameStatsPage /></ProtectedRoute>} />
      <Route path="/sponsored-tournaments" element={<ProtectedRoute><SponsoredTournamentsPage /></ProtectedRoute>} />
      <Route path="/friends" element={<ProtectedRoute><FriendsPage /></ProtectedRoute>} />
      <Route path="/groups" element={<ProtectedRoute><GroupsPage /></ProtectedRoute>} />
      <Route path="/groups/:groupId" element={<ProtectedRoute><GroupDetailPage /></ProtectedRoute>} />
      <Route path="/notifications" element={<ProtectedRoute><NotificationsPage /></ProtectedRoute>} />
      <Route path="/notifications/settings" element={<ProtectedRoute><NotificationSettingsPage /></ProtectedRoute>} />
      <Route path="/notifications/saved-alerts" element={<ProtectedRoute><SavedAlertsPage /></ProtectedRoute>} />
      {/* /shop-onboarding is the LEGACY redirect — open route so logged-out
          users get sent straight to /register-shop instead of bouncing
          through /login first. Strict-separation lockdown. */}
      <Route path="/shop-onboarding" element={<ShopOnboardingPage />} />
      <Route path="/publisher-onboarding" element={<ProtectedRoute><PublisherOnboardingPage /></ProtectedRoute>} />
      <Route path="/shop-leaderboard" element={<ProtectedRoute><ShopLeaderboardPage /></ProtectedRoute>} />
      <Route path="/groups/recurring" element={<ProtectedRoute><RecurringGroupsPage /></ProtectedRoute>} />
      <Route path="/groups/recurring/create" element={<ProtectedRoute><CreateRecurringGroupPage /></ProtectedRoute>} />
      <Route path="/groups/recurring/:groupId" element={<ProtectedRoute><RecurringGroupDetailPage /></ProtectedRoute>} />
      <Route path="/leagues" element={<ProtectedRoute><LeaguesPage /></ProtectedRoute>} />
      <Route path="/leagues/create" element={<ProtectedRoute><CreateLeaguePage /></ProtectedRoute>} />
      <Route path="/leagues/:leagueId" element={<ProtectedRoute><LeagueDetailPage /></ProtectedRoute>} />
      <Route path="/shop-locator" element={<ProtectedRoute><ShopLocatorPage /></ProtectedRoute>} />
      <Route path="/bot-practice" element={<ProtectedRoute><BotPracticePage /></ProtectedRoute>} />
      <Route path="/check-in" element={<ProtectedRoute><CheckInPage /></ProtectedRoute>} />
      <Route path="/push-settings" element={<ProtectedRoute><PushSettingsPage /></ProtectedRoute>} />
      <Route path="/mobile-discover" element={<ProtectedRoute><MobileDiscoveryPage /></ProtectedRoute>} />
      <Route path="/collection" element={<ProtectedRoute><MyCollectionPage /></ProtectedRoute>} />
      <Route path="/character-sheets" element={<ProtectedRoute><CharacterSheetsPage /></ProtectedRoute>} />
      <Route path="/wargame-rosters" element={<ProtectedRoute><WargameRostersPage /></ProtectedRoute>} />
      <Route path="/game-pdfs" element={<ProtectedRoute><GameRulesPdfPage /></ProtectedRoute>} />
    </>
  );
}

function OnboardingPage() {
  const navigate = useNavigate();
  const handleComplete = () => { navigate('/home', { replace: true }); };
  const handleSkip = () => { navigate('/home', { replace: true }); };
  return <OnboardingWizard onComplete={handleComplete} onSkip={handleSkip} />;
}
